module.exports = "<a target=\"_blank\" href=\"<%= permalink %>\"><img src=\"<%= media_url %>\" alt=\"\"></a>\n\n";